import React from 'react';
import { RegisterOptions, ControllerFieldState } from 'react-hook-form';
import i18n from '../i18n';
import { Icon, Popup } from 'semantic-ui-react';

interface IFormFieldError {
  content: string;
  style?: any
}

export function getError(fieldState: ControllerFieldState, noErrorMessage?, style?): IFormFieldError | boolean {
  return noErrorMessage ? true : {
    content: fieldState?.error?.message || i18n.t('Please fill in this field'),
    style: { position: 'absolute', zIndex: 9, marginTop: '-12px', ...style, maxWidth: 300, border: 'none' }
  };
}

export function getLabel(
  label: string | JSX.Element,
  rules: Omit<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>,
  fieldState?: ControllerFieldState,
  withoutAsterisk?: boolean,
  noErrorMessage?: boolean
): string | JSX.Element {
  if (typeof label === 'object') {
    return <label style={{ display: 'flex', alignItems: 'baseline', marginBottom: '0.5rem' }}>
      {fieldState?.error?.message && <Popup
        content={fieldState?.error?.message}
        trigger={<Icon name={'warning circle'} color='red' style={{ fontSize: '1.2em' }}/>}
      />}
      {label}
    </label>
  } else {
    if (rules && rules.required) {
      return (
        <label style={{ textAlign: 'left', display: 'block', width: 'fit-content' }}>
          {fieldState?.error?.message && !noErrorMessage && <Popup
            content={fieldState?.error?.message}
            trigger={<Icon name={'warning circle'} color='red' style={{ fontSize: '1.2em' }}/>}
          />}
          {label}
          {!withoutAsterisk && <span style={{ color: 'red' }}>*</span>}
        </label>
      );
    }
    return label ? <label>{label}</label> : null;
  }
}
